module.exports = __webpack_public_path__ + "static/img/robotBg.f4bdc01d.png";